import { Injectable, EventEmitter } from "@angular/core";
import { AbstractControl, ValidationErrors, Validators } from "@angular/forms";
import { environment } from "../../../../environments/environment";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
  providedIn: "root"
})
/*
interface ItemType {
  'customer',
  'facility',
  'unit',
  'system',
  'asset',
  'alarm'
} */


export class ConfigurationUtilService {
  alarmCreated = new EventEmitter<any[]>();
  alarmUpdated = new EventEmitter<{}>();

  // str :

  constructor(private translate: TranslateService) { }

  // findItemByIdFromItemList(itemList, itemName)

  filterFacilityByCustomerId(facilityList, customerId) {
    return facilityList.filter(f => {
      return f.enterprise === customerId;
    });
  }

  filterUnitByFacilityId(unitList, facilityId) {
    return unitList.filter(f => {
      return (f.facility && f.facility._id) === facilityId;
    });
  }

  filterSystemByUnitId(systemList, unitId) {
    return systemList.filter(f => {
      if (unitId)
        return (f.unit && f.unit._id) === unitId;
      else
        return true;
    });
  }

  filterAssetBySystemId(assetList, systemId) {
    return assetList.filter(f => {
      for (const system of f.system) {
        if (system._id === systemId) {
          return true;
        }
      }
      return false;
    });
  }

  filterSubsystemBySystemId(subsystemList, systemId) {
    // TODO: If in future, system field becomes array, implement similar to asset above.
    return subsystemList.filter(subsystem =>
      subsystem.system && subsystem.system._id == systemId
    );
  }

  getNameFieldFromListUsingId(id: string, list) {
    for (const obj of list) {
      if (obj._id === id) {
        return obj.name;
      }
    }
  }

  addDataToList(data: any, dataList: any[], dataList2?: any[]) {
    if (Array.isArray(data)) {
      data.forEach(element => {
        dataList.push(element);
      });
    } else {
      dataList.push(data);
    }
    if (dataList2) {
      this.addDataToList(data, dataList2);
    }
    console.log("After addition local list with data", data, dataList);
  }

  deleteDataFromList(id: string, dataList: any[], dataList2?: any[]) {
    for (let i = 0; i < dataList.length; i++) {
      const element = dataList[i];
      if (element._id === id) {
        dataList.splice(i, 1);
      }
    }
    if (dataList2) {
      this.deleteDataFromList(id, dataList2);
    }
    console.log("After deletion new local list", dataList);
  }

  updateDataInList(data: any, dataList: any[], dataList2?: any[]) {
    for (let i = 0; i < dataList.length; i++) {
      const element = dataList[i];
      if (element._id === data._id) {
        dataList[i] = data;
      }
    }
    if (dataList2) {
      this.updateDataInList(data, dataList2);
    }
  }

  getCommaSeparatedItemsFromArray(dataList: any[]){
    let str = '';
    dataList.forEach(data => {
        str += data + ',';
    });
    return str.slice(0,-1);
  }

  noWhiteSpace(control: AbstractControl): ValidationErrors | null {
    if (control.value == undefined) {
      return null
    }
    if ((control.value as string).trim().length === 0) {
      return { noWhiteSpace: true }
    }
    return null;
  }

  ipAddressRegex = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

  // numValueErrorIf(control2, compare): ValidatorFn {

  //   return (control: AbstractControl): ValidationErrors | null => {
  //     let val1 = Number(control.value), val2 = Number(control2.value)
  //     console.log(val1,val2, "VVVVVVVVVVVVVVVV", compare)
  //    switch (compare){
  //     case "<":
  //       if(val1 < val2) return {valueComparisionError: true}
  //       else return null
  //     case "<=":
  //       if(val1 <= val2) return {valueComparisionError: true}
  //       else return null
  //     case ">":
  //       if(val1 > val2) return {valueComparisionError: true}
  //       else return null
  //     case ">=":
  //       if(val1 >= val2) return {valueComparisionError: true}
  //       else return null
  //     default:
  //       return null
  //    }
  //   }
  // }

  validator() {
    return Validators.pattern('[^\\\\|/|\'|`|"|*|:|;|=|{}|%|+|^|!|-|\x00-\x19]*')
  }
  emailValidator() {
    return "please enter the correct email format"
  }
  emailCheck() {
    return Validators.pattern('[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]{1,}@[a-zA-Z0-9.-]{2,}[.]{1}[a-zA-Z]{2,}')
  }
  validatorLengthforTagId() {
    let maxLength = 48
    if (environment.runtime.LEN_OPTIMIZED_DB_STRUCTURE)
      maxLength = 64
    return Validators.maxLength(maxLength)
  }

  required(field?: string){
    return field ? this.translate.instant('VALIDATION.FIELD_REQUIRED', { field }) : "required"
  }
  specialCharacters(){
    return "having special characters, please avoid using that"
  }
  lengthforTagId() {
    let maxLength = 48
    if (environment.runtime.LEN_OPTIMIZED_DB_STRUCTURE)
      maxLength = 64
    return `having length greater than ${maxLength}`
  }

  checkValidInstrumentRange(l: any, u: any): boolean {
    const isValid = (v: any) => v !== null && v !== undefined && String(v).trim() !== '';
    return isValid(l) || isValid(u);
  }

  ifAssetPresentInTag(assetIdArr: string[], tag: any): boolean {
    const asset = tag?.asset;
    if (!asset || !Array.isArray(asset) || !assetIdArr?.length) return false;
    for (let i = 0; i < asset.length; i++) {
      if (assetIdArr.indexOf(asset[i]?._id) > -1) {
        return true;
      }
    }
    return false;
  }

  toString(n: any): string {
    if (n === null || n === undefined) return '';
    return typeof n === "string" ? n : n.toString();
  }

  getIOWCriticalityString(ic: any): string {
    switch (Number(ic)) {
      case 1:
        return 'L';
      case 2:
        return 'S';
      case 3:
        return 'C';
      case 4:
        return 'SC';
      default:
        return 'L';
    }
  }

  /**
   * Parses CSV boolean values across common string and numeric formats.
   * Supports 'true'/'false', 'y'/'n', 'yes'/'no', '1'/'0', and native booleans.
   * Falls back to `defaultValue` if unpopulated or unrecognized.
   */
  parseCSVBoolean(value: any, defaultValue: boolean = false): boolean {
    if (value === undefined || value === null || String(value).trim() === '') {
      return defaultValue;
    }
    if (typeof value === 'boolean') {
      return value;
    }
    const strVal = String(value).trim().toLowerCase();
    if (strVal === 'true' || strVal === 'y' || strVal === 'yes' || strVal === '1') {
      return true;
    }
    if (strVal === 'false' || strVal === 'n' || strVal === 'no' || strVal === '0') {
      return false;
    }
    return defaultValue;
  }

  /**
   * Maps Data Quality detection and alert flags from a tag/template object into CSV row columns.
   * Safely casts existing `dqDetection` / `dqAlertGeneration` map values to boolean flags for export.
   */
  getDQFieldsForCsvRow(item: any) {
    return {
      flatline_detection: Boolean(item?.dqDetection?.['4']),
      missing_data_detection: Boolean(item?.dqDetection?.['8']),
      outlier_detection: Boolean(item?.dqDetection?.['1']),
      out_of_range_detection: Boolean(item?.dqDetection?.['2']),
      erratic_detection: Boolean(item?.dqDetection?.['16']),
      flatline_alert: Boolean(item?.dqAlertGeneration?.['4']),
      missing_data_alert: Boolean(item?.dqAlertGeneration?.['8']),
      outlier_alert: Boolean(item?.dqAlertGeneration?.['1']),
      out_of_range_alert: Boolean(item?.dqAlertGeneration?.['2']),
      erratic_alert: Boolean(item?.dqAlertGeneration?.['16']),
    };
  }

}
